import React from 'react';

const Unauthorized = () => {
  return <div>You are not authorized to access these resources. Please contact your system administrator.</div>;
};

export default Unauthorized;
